import { CONSENT_COOKIE, GPP_COOKIE, META_COOKIE, TC_COOKIE } from "./constants";
import type { ConsentState } from "./types";

export function readCookie(name: string): string | null {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}

export function writeCookie(name: string, value: string, days = 365) {
  document.cookie = `${name}=${encodeURIComponent(value)};path=/;max-age=${days * 86400};SameSite=Lax`;
}

export function deleteCookie(name: string) {
  document.cookie = `${name}=;path=/;max-age=0`;
  document.cookie = `${name}=;path=/;max-age=0;domain=${location.hostname}`;
  document.cookie = `${name}=;path=/;max-age=0;domain=.${location.hostname}`;
}

export function readTcString() { return readCookie(TC_COOKIE); }
export function writeTcString(tc: string) { writeCookie(TC_COOKIE, tc); }

export type StoredMeta = {
  configVersion: number;
  gvlVersion: number;
  consentId: string;
  regime?: string;
  consentedAt?: string;
  vendorIds?: number[];
  purposeIds?: number[];
  schema?: number;
};

export function readMeta(): StoredMeta | null {
  try { const raw = readCookie(META_COOKIE); return raw ? JSON.parse(raw) as StoredMeta : null; }
  catch { return null; }
}
export function writeMeta(meta: StoredMeta) { writeCookie(META_COOKIE, JSON.stringify(meta)); }

export function readConsentState(): ConsentState | null {
  try { const raw = readCookie(CONSENT_COOKIE); return raw ? JSON.parse(raw) as ConsentState : null; }
  catch { return null; }
}
export function writeConsentState(state: ConsentState) { writeCookie(CONSENT_COOKIE, JSON.stringify(state)); }

export function writeGppString(value: string) { writeCookie(GPP_COOKIE, value); }
export function readGppString() { return readCookie(GPP_COOKIE); }

export function purgeCookies(patterns: string[]) {
  const names = document.cookie.split(";").map((c) => c.trim().split("=")[0]).filter(Boolean);
  for (const name of names) {
    for (const pat of patterns) {
      try {
        const re = pat.startsWith("/") && pat.endsWith("/")
          ? new RegExp(pat.slice(1, -1))
          : new RegExp("^" + pat.replace(/\*/g, ".*") + "$");
        if (re.test(name)) deleteCookie(name);
      } catch { /* ignore */ }
    }
  }
}
